import type { PromptCard } from './types';

export const PROMPTS: PromptCard[] = [
  {
    id: 'last-boat',
    title: 'The Last Boat',
    scene: 'A stranger is holding the final rope on a night ferry. What you send becomes three times more useful to them. They decide what comes back.',
    riskQuestion: 'How much of your ten signal coins do you let cross the water?'
  },
  {
    id: 'shared-map',
    title: 'The Shared Map',
    scene: 'You found half a map. A stranger found the other half. Trust makes the route richer; betrayal leaves you walking home with less.',
    riskQuestion: 'How much of the route do you reveal first?'
  },
  {
    id: 'glass-bridge',
    title: 'The Glass Bridge',
    scene: 'Every coin you slide across lights a panel under someone else’s feet. They can strengthen the bridge back—or walk away brighter than you.',
    riskQuestion: 'How far onto the bridge do you step?'
  },
  {
    id: 'borrowed-fire',
    title: 'Borrowed Fire',
    scene: 'You can pass a flame to a stranger. It triples warmth on their side. They may return enough heat to leave both camps glowing.',
    riskQuestion: 'How much of your fire do you risk losing?'
  }
];

export function promptById(id: string): PromptCard {
  return PROMPTS.find((prompt) => prompt.id === id) ?? PROMPTS[0];
}
